import React, { useState } from 'react';
import axios from 'axios';

import {
  OuterLogIn,
  LogInHeader,
  SubHeader,
  Reset,
  ResetWrapper,
} from './styles';
import HudsonLogo from '../../components/hudsonlogos-01.png';
import LinkButton from '../../components/LinkButton';
import MediaButtons from '../../components/MediaButtons';
import MediaInputs from '../../components/MediaInputs';
import AuthenticationLayout from './AuthenticationLayout';

const ForgotPassword = () => {
  const [resetInstructions, setResetInstructions] = useState(false);
  const [email, setEmail] = useState('');
  function handleClick(e: any) {
    if (e.key === 'Enter') 
    {
      handleChange();
    }
   }
  const onForgotPasswordSubmit = async () => {
    await axios.post(`/api/clientaccount/SendResetToken`, {
      email: email.trim(),
    });
  };
  const handleChange = () => {
    if (email === '') {
      return;
    }
    setResetInstructions(true);
    onForgotPasswordSubmit();
  };
  return (
    <AuthenticationLayout>
    <OuterLogIn maxHeight='596px' onKeyDown={handleClick}>
      <div
        style={{
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div style={{ textAlign: 'left' }}>
          <img src={HudsonLogo} style={{ width: 105, height: 42 }} alt=''/>
          {resetInstructions ? (
            <ResetWrapper>
              <Reset>Reset instructions have been sent</Reset>
              <div
                style={{
                  marginTop: 45,
                  maxWidth: 480,
                  lineHeight: 1.5,
                  marginBottom: 16,
                }}
              >
                Please check your inbox and follow further instructions to reset
                your password.
              </div>
              <LinkButton linkText='Back to Log In' href='/login' />
            </ResetWrapper>
          ) : (
            <>
              <LogInHeader>Forgot Password</LogInHeader>
              <SubHeader>
                Enter your email to receive a password reset link. You may need
                to unblock no-reply@hudsonsearch.com.
              </SubHeader>
              <MediaInputs
                widthMobile='318px'
                widthDesktop='416px'
                inputType='InputBase'
                placeholder='Email'
                value={email}
                onChange={(e: any) => setEmail(e.target.value)}
                labelText='Email'
              />
              <MediaButtons
                widthMobile='343px'
                widthDesktop='444px'
                onClick={handleChange}
                buttonType='ButtonPrimaryTwoLarge'
                buttonText='Submit'
              />
              <LinkButton linkText='Back to Log In' href='/login' />
            </>
          )}
        </div>
      </div>
    </OuterLogIn>
    </AuthenticationLayout>
  );
};

export default ForgotPassword;
